webpackJsonp([0],{

/***/ "/5xu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/utop.18cf0cb.png";

/***/ }),

/***/ "01iT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preloader',
  props: ['show'],
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "0e4D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/phantom_t.87021d5.png";

/***/ }),

/***/ "1nJf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/blur.f99808a.png";

/***/ }),

/***/ "2AE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__ = __webpack_require__("6h/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4bb9af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__ = __webpack_require__("R5UZ");
function injectStyle (ssrContext) {
  __webpack_require__("PQSB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c4bb9af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4bb9af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Logo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3MYv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Uj3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAQAAAATQsYqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAACjSURBVBjTbc8xDoJAEEbht0uyId7HA2zPFITQUNBYaKw8jdHCxoIGGjL0HMD7WJAQLQQCyLT/V7wxemFPLj2bpwFPXhZPRqlukzhKMrwlpSam+mfqqIipSa10JBTImqmjQihIpLMgPfnAwomEA8mlBzMLzGiJ5A26o8GPZEKgAXcOtERAg+fBcfzZzCoMV060gOfGWT7jYhaxP8aSrNDAWBL4AqywOJCACtk0AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTEwLTE4VDE0OjU0OjQ5KzAwOjAwuqrCNAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0xMC0xOFQxNDo1NDo0OSswMDowMMv3eogAAAAASUVORK5CYII="

/***/ }),

/***/ "58LO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "5jEh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6h/q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logo',
  props: ['show', 'active'],
  data: function data() {
    return {};
  },

  methods: {
    isActive: function isActive() {
      return this.active !== 1;
    }
  }
});

/***/ }),

/***/ "7oEc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logo',
  props: ['active'],
  data: function data() {
    return {};
  },

  methods: {
    isActive: function isActive() {
      return this.active === 1 || this.active === 5;
    },
    goTop: function goTop() {
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),

/***/ "8bWK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'leftBlock',
  props: ['active'],
  data: function data() {
    return {
      url: __webpack_require__("0e4D")
    };
  },

  methods: {
    isShow: function isShow() {
      return this.active === 2 || this.active === 3 || this.active === 4;
    },
    showName: function showName(index) {
      return this.active === index;
    },
    isShowContent: function isShowContent(index) {
      return this.active === index;
    }
  },
  components: {},
  watch: {
    active: function active() {
      if (this.active === 2) {
        this.url = __webpack_require__("0e4D");
      } else if (this.active === 3) {
        this.url = __webpack_require__("onfS");
      } else if (this.active === 4) {
        this.url = __webpack_require__("wErx");
      }
    }
  }
});

/***/ }),

/***/ "ADVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RightBlock_vue__ = __webpack_require__("jHNU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4b93d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RightBlock_vue__ = __webpack_require__("CNbG");
function injectStyle (ssrContext) {
  __webpack_require__("QvLU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b4b93d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RightBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b4b93d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_RightBlock_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CGHv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ttop.30d18ec.png";

/***/ }),

/***/ "CNbG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-block"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    class: {
      showModal: _vm.showModal
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.closeModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('img', {
    staticClass: "cross",
    attrs: {
      "src": __webpack_require__("JA1j"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-top"
  }, [_c('div', {
    staticClass: "select-wrapper"
  }, [_c('div', {
    staticClass: "select-box",
    on: {
      "click": _vm.openSelect
    }
  }, [_c('p', {
    staticClass: "selected"
  }, [_vm._v(_vm._s(_vm.selected))]), _vm._v(" "), _c('ul', {
    staticClass: "select-list",
    class: {
      open: _vm.selectOpen
    }
  }, _vm._l((_vm.selectList), function(item) {
    return _c('li', {
      staticClass: "select-item",
      on: {
        "click": function($event) {
          _vm.changeSelect(item)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "arrow-box",
    on: {
      "click": _vm.openSelect
    }
  }, [_c('img', {
    staticClass: "arrow",
    class: {
      opened: _vm.selectOpen
    },
    attrs: {
      "src": __webpack_require__("3Uj3"),
      "alt": "select"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "select-wrapper _size"
  }, [_c('div', {
    staticClass: "select-box _small",
    on: {
      "click": _vm.openSelectSpec
    }
  }, [_c('p', {
    staticClass: "selected"
  }, [_vm._v(_vm._s(_vm.selectedItem))]), _vm._v(" "), _c('ul', {
    staticClass: "select-list",
    class: {
      open: _vm.selectOpenSpec
    }
  }, _vm._l((_vm.itemList), function(items) {
    return _c('li', {
      staticClass: "select-item _small-item",
      on: {
        "click": function($event) {
          _vm.changeSelectItem(items)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(items) + "\n\n\n\t\t\t\t\t\t\t")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "arrow-box",
    on: {
      "click": _vm.openSelectSpec
    }
  }, [_c('img', {
    staticClass: "arrow",
    class: {
      opened: _vm.selectOpenSpec
    },
    attrs: {
      "src": __webpack_require__("3Uj3"),
      "alt": "select"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "price-block"
  }, [_c('p', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm.price))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-middle"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.openFinalModal(1)
      }
    }
  }, [_c('span', {
    staticClass: "btn-text"
  }, [_vm._v("Самовывоз в Новосибирск")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "text-big"
  }, [_vm._v("Уточняйте наличие!")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.openFinalModal(2)
      }
    }
  }, [_c('span', {
    staticClass: "btn-text"
  }, [_vm._v("Бесплатная доставка по Новосибирску")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("Оплаченные сноуборды отправляем в пункты выдачи СДЭК.")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.openFinalModal(3)
      }
    }
  }, [_c('span', {
    staticClass: "btn-text"
  }, [_vm._v("Бесплатная доставка по России")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper",
    class: {
      showModal: _vm.showModalFinal
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.closeFinalModal()
      }
    }
  }, [_c('div', {
    staticClass: "modal-content _final"
  }, [_c('div', {
    staticClass: "header",
    on: {
      "click": function($event) {
        _vm.closeFinalModal()
      }
    }
  }, [_c('img', {
    staticClass: "cross",
    attrs: {
      "src": __webpack_require__("JA1j"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-middle"
  }, [_c('form', {
    attrs: {
      "action": "https://money.yandex.ru/eshop.xml",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        _vm.submitForm(this, $event)
      }
    }
  }, [_c('input', {
    attrs: {
      "required": "",
      "name": "shopId",
      "value": "161606",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "required": "",
      "name": "scid",
      "value": "713884",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "required": "",
      "name": "sum",
      "value": "45000",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "paymentType",
      "value": "AC",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData),
      expression: "formData"
    }],
    attrs: {
      "name": "ym_merchant_receipt",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.formData)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "name": "customerNumber",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.computedModel),
      expression: "computedModel"
    }],
    attrs: {
      "name": "orderDetails",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.computedModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.computedModel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "name": "custName",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mail),
      expression: "mail"
    }],
    attrs: {
      "name": "custEmail",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.computedAddress),
      expression: "computedAddress"
    }],
    attrs: {
      "name": "custAddr",
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.computedAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.computedAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Имя")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "name": "customerName",
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "required": "",
      "name": "customerContact",
      "placeholder": "+79999999999",
      "id": "phone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "mail"
    }
  }, [_vm._v("Электронная почта")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mail),
      expression: "mail"
    }],
    attrs: {
      "required": "",
      "name": "customerMail",
      "id": "mail",
      "type": "email"
    },
    domProps: {
      "value": (_vm.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showInput()) ? _c('label', {
    staticClass: "label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Адрес")]) : _vm._e(), _vm._v(" "), (_vm.showInput()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    attrs: {
      "name": "customerAddress",
      "id": "address",
      "type": "text"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showInputCity()) ? _c('label', {
    staticClass: "label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("Город")]) : _vm._e(), _vm._v(" "), (_vm.showInputCity()) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    attrs: {
      "name": "customerCity",
      "id": "city",
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "text-big-confirm",
    attrs: {
      "for": "warning1"
    }
  }, [_vm._v("Уточняйте наличие!")]), _vm._v(" "), _c('input', {
    staticClass: "button",
    class: {
      '_disabled': !_vm.isPhone
    },
    attrs: {
      "type": "submit",
      "value": "К оплате"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden wrapper",
    class: {
      show: _vm.isShow()
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "type-block"
  }, [_c('span', {
    staticClass: "type",
    class: {
      active: _vm.isActive(1)
    },
    on: {
      "click": function($event) {
        _vm.activate(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.item1))]), _vm._v(" "), _c('span', {
    staticClass: "type",
    class: {
      active: _vm.isActive(2)
    },
    on: {
      "click": function($event) {
        _vm.activate(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.item2))]), _vm._v(" "), _c('span', {
    staticClass: "type",
    class: {
      active: _vm.isActive(3)
    },
    on: {
      "click": function($event) {
        _vm.activate(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.item3))]), _vm._v(" "), (_vm.item4) ? _c('span', {
    staticClass: "type",
    class: {
      active: _vm.isActive(4)
    },
    on: {
      "click": function($event) {
        _vm.activate(4)
      }
    }
  }, [_vm._v(_vm._s(_vm.item4))]) : _vm._e(), _vm._v(" "), (_vm.item5) ? _c('span', {
    staticClass: "type",
    class: {
      active: _vm.isActive(5), none: _vm.isNone()
    },
    on: {
      "click": function($event) {
        _vm.activate(5)
      }
    }
  }, [_vm._v(_vm._s(_vm.item5))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "desc-wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "desc-amount"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "ul",
      "mode": "out-in"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: item,
      attrs: {
        "data-index": index
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item) + "\n\n\n\t\t\t\t\t\t")])
  }))], 1)]), _vm._v(" "), _c('div', [_c('buyButton', {
    attrs: {
      "active": _vm.active
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "info",
    attrs: {
      "href": "tel:+79232226828"
    }
  }, [_vm._v("+7 923 222-68-28")]), _vm._v(" "), _c('a', {
    staticClass: "info",
    attrs: {
      "href": "tel:+79628404755"
    }
  }, [_vm._v("+7 962 840-47-55")])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text"
  }, [_vm._v("Условия можно уточнить по номеру "), _c('a', {
    staticClass: "text-link",
    attrs: {
      "href": "+79232226828"
    }
  }, [_vm._v("+7 923 222-68-28")]), _vm._v(".")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc-title"
  }, [_c('ul', [_c('li', [_vm._v("жёсткость")]), _vm._v(" "), _c('li', [_vm._v("размер креплений")]), _vm._v(" "), _c('li', [_vm._v("контактная длина (см)")]), _vm._v(" "), _c('li', [_vm._v("ширина носа (см)")]), _vm._v(" "), _c('li', [_vm._v("ширина хвоста (см)")]), _vm._v(" "), _c('li', [_vm._v("ширина талии (см)")]), _vm._v(" "), _c('li', [_vm._v("ширина стойки")]), _vm._v(" "), _c('li', [_vm._v("смещение закладных (см)")]), _vm._v(" "), _c('li', [_vm._v("боковой радиус (м)")]), _vm._v(" "), _c('li', [_vm._v("вес райдера (кг)")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D+9/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ftop.f15b251.png";

/***/ }),

/***/ "D90V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Logo logo-block",
    class: {
      hidden: _vm.isActive()
    },
    on: {
      "click": function($event) {
        _vm.goTop()
      }
    }
  }, [_c('svg', {
    staticClass: "svg-logo",
    attrs: {
      "width": "0",
      "height": "0",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 367.95 137"
    }
  }, [_c('defs'), _vm._v(" "), _c('title', [_vm._v("Phantom Equipment")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "logo",
      "data-name": "logo"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "184.02 130.54 213.17 104.44 249.49 119.23 276.48 109.43 346.56 137 367.95 130.06 232.73 15.57 213.17 27.07 184.02 0 183.94 0 154.78 27.07 135.22 15.57 0 130.06 21.35 137 91.47 109.43 118.46 119.23 154.78 104.44 183.94 130.54 184.02 130.54"
    }
  })])]), _vm._v(" "), _c('svg', {
    staticClass: "svg-text subtitle",
    attrs: {
      "width": "0",
      "height": "0",
      "data-name": "text",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 828.79 107.83"
    }
  }, [_c('defs'), _vm._v(" "), _c('title', [_vm._v("Phantom Equipment")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "text",
      "data-name": "text"
    }
  }, [_c('path', {
    attrs: {
      "d": "M226.09,545.19h69.6a42.77,42.77,0,0,1,12.76,1.65,23.1,23.1,0,0,1,8.46,4.52,16.78,16.78,0,0,1,4.68,6.65,22.42,22.42,0,0,1,1.44,8c0,.11,0,2.7,0,2.81a22.6,22.6,0,0,1-1.43,7.82,16.36,16.36,0,0,1-4.68,6.59,23.56,23.56,0,0,1-8.46,4.47,42.7,42.7,0,0,1-12.76,1.65H245.77v15.38H226.09Zm19.68,17v10.15h49.39a26.52,26.52,0,0,0,4.36-.27,4.63,4.63,0,0,0,2.13-.8,2,2,0,0,0,.74-1.22,10.13,10.13,0,0,0,.11-1.38c0-.05,0-2.6,0-2.65a10.74,10.74,0,0,0-.11-1.49,1.81,1.81,0,0,0-.74-1.22,5.67,5.67,0,0,0-2.13-.8,22.3,22.3,0,0,0-4.36-.32Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M420.13,583.48H359.85v21.27H340.17V545.19h19.68v21.27h60.28V545.19h19.68v59.56H420.13Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M542,595.4H487.88l-7.45,9.36H456.29l48.39-59.56h20.74l48.39,59.56H549.57Zm-42.22-14.78h30.31L515,561.36Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M670.55,604.76l-59.88-37.55v37.55H591V545.19h18.61l60,37.65V545.19h19.57v59.56Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M706.26,545.19h98.17v17H765.57v42.54H745.89V562.21H706.26Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M857.79,605.61a63.4,63.4,0,0,1-18.72-2.39,34.43,34.43,0,0,1-12.44-6.54,24.12,24.12,0,0,1-6.91-9.73,34.72,34.72,0,0,1,0-23.93,24.11,24.11,0,0,1,6.91-9.73,34.42,34.42,0,0,1,12.44-6.54,63.4,63.4,0,0,1,18.72-2.39h29.67a63.42,63.42,0,0,1,18.72,2.39,33.87,33.87,0,0,1,12.39,6.54,24.35,24.35,0,0,1,6.86,9.73,34.72,34.72,0,0,1,0,23.93,24.36,24.36,0,0,1-6.86,9.73,33.88,33.88,0,0,1-12.39,6.54,63.42,63.42,0,0,1-18.72,2.39Zm29.57-16.91a38.36,38.36,0,0,0,10-1.06,15,15,0,0,0,5.9-2.87,9.05,9.05,0,0,0,2.82-4.36,19.31,19.31,0,0,0,.74-5.42,18.77,18.77,0,0,0-.74-5.37,9.08,9.08,0,0,0-2.82-4.31,15.06,15.06,0,0,0-5.9-2.87,38.5,38.5,0,0,0-10-1.06H857.9a39.65,39.65,0,0,0-10.16,1.06,15.08,15.08,0,0,0-6,2.87A8.73,8.73,0,0,0,839,569.6a20.07,20.07,0,0,0-.69,5.37,20.66,20.66,0,0,0,.69,5.42,8.71,8.71,0,0,0,2.77,4.36,15,15,0,0,0,6,2.87,39.51,39.51,0,0,0,10.16,1.06Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1054.39,545.19v59.56h-19.68V571L998.45,603.8,962.39,571v33.72H942.72V545.19h18.72l37,33.08,37-33.08Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.61,626.26h32v3.52h-28.1v6.08h24.83v3.2H229.48v6.08h28.1v3.52h-32Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M339,649a21.48,21.48,0,0,1-6.67-.91,12.66,12.66,0,0,1-4.51-2.46,9.24,9.24,0,0,1-2.54-3.65,13,13,0,0,1,0-9,9.25,9.25,0,0,1,2.54-3.65,12.63,12.63,0,0,1,4.51-2.46,21.45,21.45,0,0,1,6.67-.91h9.34a21.45,21.45,0,0,1,6.67.91,12.64,12.64,0,0,1,4.51,2.46,9.25,9.25,0,0,1,2.54,3.65,12.51,12.51,0,0,1,.8,4.5,13,13,0,0,1-.37,3.12,10.27,10.27,0,0,1-1.14,2.78,9.57,9.57,0,0,1-2,2.35,11.38,11.38,0,0,1-2.88,1.79l8.7,4.67h-6.53l-6.37-3.49a25.57,25.57,0,0,1-4,.29Zm9.31-3.52a16.93,16.93,0,0,0,5-.62,8.6,8.6,0,0,0,3.22-1.71,6.09,6.09,0,0,0,1.73-2.54,9.77,9.77,0,0,0,0-6.24,6.1,6.1,0,0,0-1.73-2.54,8.62,8.62,0,0,0-3.22-1.71,16.93,16.93,0,0,0-5-.62H339a16.94,16.94,0,0,0-5,.62,8.6,8.6,0,0,0-3.22,1.71,6.09,6.09,0,0,0-1.73,2.54,9.77,9.77,0,0,0,0,6.24,6.07,6.07,0,0,0,1.73,2.54,8.6,8.6,0,0,0,3.2,1.71,16.78,16.78,0,0,0,5,.62Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M434.76,641.2a5.1,5.1,0,0,0,1.55,2.26,7.77,7.77,0,0,0,3,1.47,17.41,17.41,0,0,0,4.67.53h7.33a17.42,17.42,0,0,0,4.67-.53,7.78,7.78,0,0,0,3-1.47,5.1,5.1,0,0,0,1.55-2.26,8.85,8.85,0,0,0,.45-2.88V626.26h3.87v12.06a13.15,13.15,0,0,1-.67,4.27,7.84,7.84,0,0,1-2.26,3.38,11.12,11.12,0,0,1-4.16,2.21,21.82,21.82,0,0,1-6.38.8h-7.39a21.81,21.81,0,0,1-6.38-.8,11.12,11.12,0,0,1-4.16-2.21,7.83,7.83,0,0,1-2.26-3.38,13.13,13.13,0,0,1-.67-4.27V626.26h3.87v12.06A8.85,8.85,0,0,0,434.76,641.2Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M533.86,626.26h3.87v22.4h-3.87Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M607.46,626.26h24.38a13.59,13.59,0,0,1,4.16.56,7.55,7.55,0,0,1,2.8,1.54,5.89,5.89,0,0,1,1.57,2.27,7.69,7.69,0,0,1,.5,2.77,7.78,7.78,0,0,1-.5,2.8,5.76,5.76,0,0,1-1.57,2.26A7.52,7.52,0,0,1,636,640a13.94,13.94,0,0,1-4.16.54H611.33v8.16h-3.87Zm3.87,3.52V637h20.42a9.28,9.28,0,0,0,2.45-.27,4.12,4.12,0,0,0,1.55-.75,2.64,2.64,0,0,0,.82-1.14,4.11,4.11,0,0,0,.24-1.42,4,4,0,0,0-.24-1.39,2.76,2.76,0,0,0-.82-1.15,4.14,4.14,0,0,0-1.55-.78,8.79,8.79,0,0,0-2.45-.29Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M746.41,626.26v22.4h-3.87V631.6l-15.46,16.26L711.59,631.6v17.06h-3.87v-22.4h3.71l15.65,16.32,15.62-16.32Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M816.13,626.26h32v3.52H820v6.08h24.83v3.2H820v6.08h28.1v3.52h-32Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M920.36,630.8v17.86h-3.87v-22.4h3.68l26.53,17.86V626.26h3.87v22.4h-3.68Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1017.35,626.26h36v3.52h-16.06v18.88h-3.9V629.78h-16.06Z",
      "transform": "translate(-225.61 -544.34)"
    }
  })])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HA1T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J8Hx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ubase.4f3d5b9.png";

/***/ }),

/***/ "JA1j":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAANVJREFUOI2V1LsJwzAQgOHfFqS4VkOk9BoBQzoPkeyQIdLYQwTSBTyEJzGoVmVIEQsUrOc1xpL5dCcf12itT8ALmI0xExWhtb4BF2BQIvIGrkAvIqu1dqlARuAMdC0we/vj/kEp4mJW1tpFRFag3xeTmQWQuzFmUgClWAwBUG4lh6UQgKYk9f0ZRYJQBPPjgIBXmh+BMpMIQBs5tTqCGSVKi7bGAYpc9odMa/xBsV9c0mcqh7iXHKZKkBJMlSI5TInIg98oyCIJbHPzqAOeNYPNwzZg+ALHRq6v8yRd8gAAAABJRU5ErkJggg=="

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc2d6e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("zzH9");
function injectStyle (ssrContext) {
  __webpack_require__("5jEh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc2d6e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_touch_events__ = __webpack_require__("ufW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_touch_events__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_touch_events___default.a, {
  disableClick: false,
  touchClass: '',
  tapTolerance: 10,
  swipeTolerance: 60
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OGbF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-component"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._v("Наверх")])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "copyright"
  }, [_vm._v("2017. Сноуборды Phantom Equipment."), _c('br'), _vm._v("Все права защищены.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "footer-link-vk",
    attrs: {
      "href": "https://vk.com/phantom.equipment"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("R77y"),
      "width": "45",
      "height": "45"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OPWT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buyButton_vue__ = __webpack_require__("dw6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdf90a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_buyButton_vue__ = __webpack_require__("TCgf");
function injectStyle (ssrContext) {
  __webpack_require__("XDhb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bdf90a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buyButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bdf90a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_buyButton_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PA35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blackLogo_vue__ = __webpack_require__("7oEc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b46496_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_blackLogo_vue__ = __webpack_require__("D90V");
function injectStyle (ssrContext) {
  __webpack_require__("Y4bU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52b46496"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blackLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52b46496_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_blackLogo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PQSB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QNcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-block"
  }, [_c('div', {
    staticClass: "left-block-text hidden",
    class: {
      show: _vm.isShow()
    }
  }, [_c('div', {
    staticClass: "left-block-text-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('img', {
    staticClass: "board-name",
    attrs: {
      "src": _vm.url,
      "alt": "board-logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "board-wrapper"
  }, [_c('img', {
    staticClass: "board",
    class: {
      show: _vm.isShowContent(2)
    },
    attrs: {
      "src": __webpack_require__("58LO")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board",
    class: {
      show: _vm.isShowContent(3)
    },
    attrs: {
      "src": __webpack_require__("ioyw")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board",
    class: {
      show: _vm.isShowContent(4)
    },
    attrs: {
      "src": __webpack_require__("Qw3R")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('img', {
    staticClass: "chart",
    class: {
      show: _vm.isShowContent(2)
    },
    attrs: {
      "src": __webpack_require__("daoO")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "chart",
    class: {
      show: _vm.isShowContent(3)
    },
    attrs: {
      "src": __webpack_require__("S9P5")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "chart",
    class: {
      show: _vm.isShowContent(4)
    },
    attrs: {
      "src": __webpack_require__("kkaB")
    }
  })])]), _vm._v(" "), (_vm.isShowContent(2)) ? [_vm._m(0)] : _vm._e(), _vm._v(" "), (_vm.isShowContent(3)) ? [_vm._m(1)] : _vm._e(), _vm._v(" "), (_vm.isShowContent(4)) ? [_vm._m(2)] : _vm._e()], 2)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "item"
  }, [_vm._v("Геометрия True Twin")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Прогиб Rocker-Camber-Rocker")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("База Durasurf Sintered 4001/8.1M")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Стеклоткань Tri-Ax + Carbon")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Боковые стенки Extruded UHMW")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Сердечник Клён/Липа")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Смола "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carbon AERO")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Армирование кантов "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("KEEN System")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "item"
  }, [_vm._v("Геометрия Directional")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Прогиб Rocker-Camber")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("База Durasurf Sintered 4001/8.1M")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Стеклоткань Tri-Ax + Carbon")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Боковые стенки Extruded UHMW")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Сердечник Клён/Липа")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Смола "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carbon AERO")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Армирование кантов "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("KEEN System")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "item"
  }, [_vm._v("Геометрия Directional Twin")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Прогиб Rocker-Camber-Rocker")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("База Durasurf Sintered 4001/8.1M")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Стеклоткань Tri-Ax + Carbon")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Боковые стенки Extruded UHMW")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Сердечник Клён/Липа")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Смола "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Carbon AERO")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v("Армирование кантов "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("KEEN System")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QSgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Content"
  }, [_c('preloader', {
    attrs: {
      "show": _vm.show
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img bcg-img",
    style: ({
      backgroundPositionX: _vm.pos + '%'
    })
  }, [_c('div', {
    staticClass: "nav-block",
    class: {
      showNav: _vm.show
    }
  }, [_c('a', {
    class: {
      active: _vm.isActive(1)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(1)
      }
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(2)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(2)
      }
    }
  }, [_vm._v("Freestyle")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(3)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(3)
      }
    }
  }, [_vm._v("Freeride")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(4)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(4)
      }
    }
  }, [_vm._v("Universal")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(5)
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.posfunc(5)
      }
    }
  }, [_vm._v("Contacts")]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.isActive(6)
    },
    attrs: {
      "href": "https://en.phantom.equipment"
    }
  }, [_vm._v("ENG")])]), _vm._v(" "), _c('Logo', {
    attrs: {
      "show": _vm.show,
      "active": _vm.activeItem
    }
  })], 1), _vm._v(" "), _c('img', {
    staticClass: "blur",
    class: {
      showBlur: _vm.isBlur(2)
    },
    attrs: {
      "src": __webpack_require__("1nJf"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "blur",
    class: {
      showBlur: _vm.isBlur(3)
    },
    attrs: {
      "src": __webpack_require__("1nJf"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "blur",
    class: {
      showBlur: _vm.isBlur(4)
    },
    attrs: {
      "src": __webpack_require__("1nJf"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mainContent",
    class: {
      display: _vm.displayMain()
    }
  }, [_c('leftBlock', {
    attrs: {
      "active": _vm.activeItem
    }
  }), _vm._v(" "), _c('board', {
    attrs: {
      "active": _vm.activeItem
    }
  }), _vm._v(" "), _c('rightBlock', {
    attrs: {
      "active": _vm.activeItem
    }
  }), _vm._v(" "), _c('blackLogo', {
    staticClass: "logo-black",
    attrs: {
      "active": _vm.activeItem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-wrapper",
    staticStyle: {
      "margin": "90px auto 0"
    }
  }, [(_vm.isActive(2)) ? [_c('h3', {
    staticClass: "mainPage-text text-header"
  }, [_vm._v("Freestyle")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-bottom text-content"
  }, [_vm._v("Phantom T — машина для бэккантти-фристайла, на которой можно уверенно прыгать как с пушистых дропов, так и в парке. Классический кембер в сочетании с умеренными рокерами на носу и хвосте, позволяет этому твин-типу иметь отличную отдачу на жестком склоне и всплывать в пухляке. Спеченый скользяк с финишной обработкой и базовым парафином, деревянный сердечник из ясеня и липы, карбоновые стрингеры, шнуровка кантов кевларом KEEN System и эпоксидная смола Carbon AERO.")])] : _vm._e(), _vm._v(" "), (_vm.isActive(3)) ? [_c('h3', {
    staticClass: "mainPage-text text-header"
  }, [_vm._v("Freeride")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-bottom text-content"
  }, [_vm._v("Phantom F – истребитель снежных пространств последнего поколения. Жесткий, быстрый и маневренный он не потопляем в глубоком снегу и режет, как масло, леденистые склоны. Спеченый скользяк с финишной обработкой и базовым парафином, деревянный сердечник из ясеня и липы, карбоновые стрингеры, шнуровка кантов кевларом KEEN System и эпоксидная смола Carbon AERO.")])] : _vm._e(), _vm._v(" "), (_vm.isActive(4)) ? [_c('h3', {
    staticClass: "mainPage-text text-header"
  }, [_vm._v("Universal")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-bottom text-content"
  }, [_vm._v("Phantom U – многоцелевая машина, способная раскрыть возможности самого опытного пилота. Жесткая трасса, глубокий снег, гигантские дропы — на него можно положиться в любых условиях. Спеченый скользяк с финишной обработкой и базовым парафином, деревянный сердечник из ясеня и липы, карбоновые стрингеры, шнуровка кантов кевларом KEEN System и эпоксидная смола Carbon AERO.")])] : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "mainPage",
    class: {
      displayMain: _vm.displayMainPage()
    }
  }, [_c('p', {
    staticClass: "mainPage-text mainPage-header"
  }, [_vm._v("COMPANY")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Путь к совершенству лежит через преодоление невозможного")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Вчера мы осваивали технологии известных производителей, чтобы создать сноуборды\n\t\t\t\tмирового уровня — сегодня мы используем собственные технологии и подходы, чтобы\n\t\t\t\tбыть на высоте. Мы создали Phantom — точный инструмент, оставляющий безупречный\n\t\t\t\tслед на любом рельефе. Спроектированные инженерами и учёными Новосибирского\n\t\t\t\tакадемгородка, собранные профессионалами из лучших материалов, сноуборды Phantom\n\t\t\t\tготовы раскрыть твой потенциал на 100%.")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-header"
  }, [_vm._v("Carbon AERO")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-subheader"
  }, [_vm._v("Carbon Alloy Epoxy Resin")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Изгибы, удары и вибрации медленно разрушают материалы изнутри. Чтобы Phantom\n\t\t\t\tслужил дольше и был твоим надёжным напарником в самых экстремальных условиях,\n\t\t\t\tмы используем эпоксидную смолу, обогащенную углеродными нанотрубками.\n\t\t\t\tВстраиваясь в полимерную матрицу смолы, нанотрубки препятствуют росту\n\t\t\t\tмикротрещин, что делает конструкцию долговечнее. Эту задачу мы решили в\n\t\t\t\tсотрудничестве с OCSiAl, мировым лидером производства углеродных нанотрубок.\n\t\t\t\tCarbon AERO — новый уровень композитных систем.")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-header"
  }, [_vm._v("KEEN System")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-subheader"
  }, [_vm._v("Kevlar Edge ENhancement System")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text mainPage-bottom"
  }, [_vm._v("Мягкий белоснежный склон нередко скрывает острые камни, которые могут испортить\n\t\t\t\tтвоё снаряжение. Сноуборд с вырванным кантом чаще всего отправляется на свалку.\n\t\t\t\tЧтобы твой отдых не омрачил досадный случай, мы связываем стальные канты по всей их\n\t\t\t\tдлине прочными кевларовыми нитями. KEEN System — твоя уверенность в каждой дуге.")]), _vm._v(" "), _c('blackLogo', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), (_vm.isActive(5)) ? _c('div', {
    staticClass: "contact"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("ООО «Техноресурс»")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Юридический адрес: 630090, г. Новосибирск, ул. Инженерная, 16")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Почтовый адрес: 630090, г. Новосибирск, ул. Инженерная, 16")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("ИНН: 5408283940")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("КПП: 540801001")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("ОГРН: 1105476084526")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("р/с: 40702810502020050096 В ПАО Банка «ФК ОТКРЫТИЕ»")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("к/сч: 30101810100000000867")]), _vm._v(" "), _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("БИК: 04500486")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('blackLogo', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p')], 1) : _vm._e(), _vm._v(" "), _c('footerComponent')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text mainPage-subheader"
  }, [_c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "https://fasie.ru/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("gAOZ"),
      "width": "180",
      "height": "120"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text"
  }, [_c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "mailto:hi@phantom.equipment"
    }
  }, [_vm._v("hi@phantom.equipment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text"
  }, [_c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "mailto:sales@phantom.equipment"
    }
  }, [_vm._v("sales@phantom.equipment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text"
  }, [_vm._v("Тел: \n\t\t\t\t"), _c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "tel:+79139274951"
    }
  }, [_vm._v("+7 913 927-49-51")]), _vm._v(",\n\t\t\t\t"), _c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "tel:+79232226828"
    }
  }, [_vm._v("+7 923 222-68-28")]), _vm._v(",\n\t\t\t")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mainPage-text mainPage-subheader"
  }, [_c('a', {
    staticClass: "mainPage-link",
    attrs: {
      "href": "https://fasie.ru/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("gAOZ"),
      "width": "180",
      "height": "120"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QvLU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qw3R":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "R5UZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Logo logo-block",
    class: {
      logoMove: _vm.show, hidden: _vm.isActive()
    }
  }, [_c('svg', {
    staticClass: "svg-logo",
    attrs: {
      "width": "0",
      "height": "0",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 367.95 137"
    }
  }, [_c('defs'), _vm._v(" "), _c('title', [_vm._v("Phantom Equipment")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "logo",
      "data-name": "logo"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "184.02 130.54 213.17 104.44 249.49 119.23 276.48 109.43 346.56 137 367.95 130.06 232.73 15.57 213.17 27.07 184.02 0 183.94 0 154.78 27.07 135.22 15.57 0 130.06 21.35 137 91.47 109.43 118.46 119.23 154.78 104.44 183.94 130.54 184.02 130.54"
    }
  })])]), _vm._v(" "), _c('p', {
    class: {
      textheaderFade: _vm.show
    },
    staticStyle: {
      "color": "#ffffff",
      "font-family": "opinionpro, serif",
      "margin-top": "5px"
    },
    attrs: {
      "id": "loading"
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "svg-text subtitle",
    class: {
      subtitleFade: _vm.show
    },
    attrs: {
      "width": "0",
      "height": "0",
      "data-name": "text",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 828.79 107.83"
    }
  }, [_c('defs'), _vm._v(" "), _c('title', [_vm._v("Phantom Equipment")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "text",
      "data-name": "text"
    }
  }, [_c('path', {
    attrs: {
      "d": "M226.09,545.19h69.6a42.77,42.77,0,0,1,12.76,1.65,23.1,23.1,0,0,1,8.46,4.52,16.78,16.78,0,0,1,4.68,6.65,22.42,22.42,0,0,1,1.44,8c0,.11,0,2.7,0,2.81a22.6,22.6,0,0,1-1.43,7.82,16.36,16.36,0,0,1-4.68,6.59,23.56,23.56,0,0,1-8.46,4.47,42.7,42.7,0,0,1-12.76,1.65H245.77v15.38H226.09Zm19.68,17v10.15h49.39a26.52,26.52,0,0,0,4.36-.27,4.63,4.63,0,0,0,2.13-.8,2,2,0,0,0,.74-1.22,10.13,10.13,0,0,0,.11-1.38c0-.05,0-2.6,0-2.65a10.74,10.74,0,0,0-.11-1.49,1.81,1.81,0,0,0-.74-1.22,5.67,5.67,0,0,0-2.13-.8,22.3,22.3,0,0,0-4.36-.32Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M420.13,583.48H359.85v21.27H340.17V545.19h19.68v21.27h60.28V545.19h19.68v59.56H420.13Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M542,595.4H487.88l-7.45,9.36H456.29l48.39-59.56h20.74l48.39,59.56H549.57Zm-42.22-14.78h30.31L515,561.36Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M670.55,604.76l-59.88-37.55v37.55H591V545.19h18.61l60,37.65V545.19h19.57v59.56Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M706.26,545.19h98.17v17H765.57v42.54H745.89V562.21H706.26Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M857.79,605.61a63.4,63.4,0,0,1-18.72-2.39,34.43,34.43,0,0,1-12.44-6.54,24.12,24.12,0,0,1-6.91-9.73,34.72,34.72,0,0,1,0-23.93,24.11,24.11,0,0,1,6.91-9.73,34.42,34.42,0,0,1,12.44-6.54,63.4,63.4,0,0,1,18.72-2.39h29.67a63.42,63.42,0,0,1,18.72,2.39,33.87,33.87,0,0,1,12.39,6.54,24.35,24.35,0,0,1,6.86,9.73,34.72,34.72,0,0,1,0,23.93,24.36,24.36,0,0,1-6.86,9.73,33.88,33.88,0,0,1-12.39,6.54,63.42,63.42,0,0,1-18.72,2.39Zm29.57-16.91a38.36,38.36,0,0,0,10-1.06,15,15,0,0,0,5.9-2.87,9.05,9.05,0,0,0,2.82-4.36,19.31,19.31,0,0,0,.74-5.42,18.77,18.77,0,0,0-.74-5.37,9.08,9.08,0,0,0-2.82-4.31,15.06,15.06,0,0,0-5.9-2.87,38.5,38.5,0,0,0-10-1.06H857.9a39.65,39.65,0,0,0-10.16,1.06,15.08,15.08,0,0,0-6,2.87A8.73,8.73,0,0,0,839,569.6a20.07,20.07,0,0,0-.69,5.37,20.66,20.66,0,0,0,.69,5.42,8.71,8.71,0,0,0,2.77,4.36,15,15,0,0,0,6,2.87,39.51,39.51,0,0,0,10.16,1.06Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1054.39,545.19v59.56h-19.68V571L998.45,603.8,962.39,571v33.72H942.72V545.19h18.72l37,33.08,37-33.08Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M225.61,626.26h32v3.52h-28.1v6.08h24.83v3.2H229.48v6.08h28.1v3.52h-32Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M339,649a21.48,21.48,0,0,1-6.67-.91,12.66,12.66,0,0,1-4.51-2.46,9.24,9.24,0,0,1-2.54-3.65,13,13,0,0,1,0-9,9.25,9.25,0,0,1,2.54-3.65,12.63,12.63,0,0,1,4.51-2.46,21.45,21.45,0,0,1,6.67-.91h9.34a21.45,21.45,0,0,1,6.67.91,12.64,12.64,0,0,1,4.51,2.46,9.25,9.25,0,0,1,2.54,3.65,12.51,12.51,0,0,1,.8,4.5,13,13,0,0,1-.37,3.12,10.27,10.27,0,0,1-1.14,2.78,9.57,9.57,0,0,1-2,2.35,11.38,11.38,0,0,1-2.88,1.79l8.7,4.67h-6.53l-6.37-3.49a25.57,25.57,0,0,1-4,.29Zm9.31-3.52a16.93,16.93,0,0,0,5-.62,8.6,8.6,0,0,0,3.22-1.71,6.09,6.09,0,0,0,1.73-2.54,9.77,9.77,0,0,0,0-6.24,6.1,6.1,0,0,0-1.73-2.54,8.62,8.62,0,0,0-3.22-1.71,16.93,16.93,0,0,0-5-.62H339a16.94,16.94,0,0,0-5,.62,8.6,8.6,0,0,0-3.22,1.71,6.09,6.09,0,0,0-1.73,2.54,9.77,9.77,0,0,0,0,6.24,6.07,6.07,0,0,0,1.73,2.54,8.6,8.6,0,0,0,3.2,1.71,16.78,16.78,0,0,0,5,.62Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M434.76,641.2a5.1,5.1,0,0,0,1.55,2.26,7.77,7.77,0,0,0,3,1.47,17.41,17.41,0,0,0,4.67.53h7.33a17.42,17.42,0,0,0,4.67-.53,7.78,7.78,0,0,0,3-1.47,5.1,5.1,0,0,0,1.55-2.26,8.85,8.85,0,0,0,.45-2.88V626.26h3.87v12.06a13.15,13.15,0,0,1-.67,4.27,7.84,7.84,0,0,1-2.26,3.38,11.12,11.12,0,0,1-4.16,2.21,21.82,21.82,0,0,1-6.38.8h-7.39a21.81,21.81,0,0,1-6.38-.8,11.12,11.12,0,0,1-4.16-2.21,7.83,7.83,0,0,1-2.26-3.38,13.13,13.13,0,0,1-.67-4.27V626.26h3.87v12.06A8.85,8.85,0,0,0,434.76,641.2Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M533.86,626.26h3.87v22.4h-3.87Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M607.46,626.26h24.38a13.59,13.59,0,0,1,4.16.56,7.55,7.55,0,0,1,2.8,1.54,5.89,5.89,0,0,1,1.57,2.27,7.69,7.69,0,0,1,.5,2.77,7.78,7.78,0,0,1-.5,2.8,5.76,5.76,0,0,1-1.57,2.26A7.52,7.52,0,0,1,636,640a13.94,13.94,0,0,1-4.16.54H611.33v8.16h-3.87Zm3.87,3.52V637h20.42a9.28,9.28,0,0,0,2.45-.27,4.12,4.12,0,0,0,1.55-.75,2.64,2.64,0,0,0,.82-1.14,4.11,4.11,0,0,0,.24-1.42,4,4,0,0,0-.24-1.39,2.76,2.76,0,0,0-.82-1.15,4.14,4.14,0,0,0-1.55-.78,8.79,8.79,0,0,0-2.45-.29Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M746.41,626.26v22.4h-3.87V631.6l-15.46,16.26L711.59,631.6v17.06h-3.87v-22.4h3.71l15.65,16.32,15.62-16.32Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M816.13,626.26h32v3.52H820v6.08h24.83v3.2H820v6.08h28.1v3.52h-32Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M920.36,630.8v17.86h-3.87v-22.4h3.68l26.53,17.86V626.26h3.87v22.4h-3.68Z",
      "transform": "translate(-225.61 -544.34)"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1017.35,626.26h36v3.52h-16.06v18.88h-3.9V629.78h-16.06Z",
      "transform": "translate(-225.61 -544.34)"
    }
  })])]), _vm._v(" "), _c('img', {
    staticClass: "desc",
    class: {
      subtitleFade: _vm.show
    },
    attrs: {
      "src": __webpack_require__("jsm/"),
      "alt": "desc"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R77y":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "Rfmr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S9P5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chartF.5b7a3f8.png";

/***/ }),

/***/ "TCgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-button"
  }, [_c('img', {
    staticClass: "wallet",
    attrs: {
      "src": __webpack_require__("yaIG"),
      "width": "30",
      "height": "30",
      "alt": "wallet"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "price hidden",
    class: {
      showPrice: _vm.isShow(2)
    }
  }, [_vm._v("45 000")]), _vm._v(" "), _c('span', {
    staticClass: "price hidden",
    class: {
      showPrice: _vm.isShow(3)
    }
  }, [_vm._v("45 000")]), _vm._v(" "), _c('span', {
    staticClass: "price hidden",
    class: {
      showPrice: _vm.isShow(4)
    }
  }, [_vm._v("45 000")]), _vm._v(" "), _c('img', {
    staticClass: "rub",
    attrs: {
      "src": __webpack_require__("xQDS"),
      "width": "14",
      "height": "16",
      "alt": "wallet"
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TXM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preload-block",
    class: {
      unload: _vm.show
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V+/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footerComponent',
  props: ['active'],
  methods: {
    scrollTop: function scrollTop() {
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),

/***/ "XDhb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y4bU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YX/p":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fbase.771ad1f.png";

/***/ }),

/***/ "Yg+W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tbase.9810cb6.png";

/***/ }),

/***/ "csnC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerComponent_vue__ = __webpack_require__("V+/n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a994d624_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_footerComponent_vue__ = __webpack_require__("OGbF");
function injectStyle (ssrContext) {
  __webpack_require__("Rfmr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a994d624"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footerComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a994d624_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_footerComponent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "daoO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "df53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftBlock_vue__ = __webpack_require__("8bWK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15db361c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LeftBlock_vue__ = __webpack_require__("QNcD");
function injectStyle (ssrContext) {
  __webpack_require__("HA1T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15db361c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15db361c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LeftBlock_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dw6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'buyButton',
  props: ['active'],
  data: function data() {
    return {};
  },

  methods: {
    isShow: function isShow(index) {
      return this.active === index;
    }
  },
  components: {}
});

/***/ }),

/***/ "eCFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_magnify__ = __webpack_require__("ZsOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_magnify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_magnify__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'board',
  props: ['active'],
  data: function data() {
    return {
      fCount: 0,
      fSrc: __webpack_require__("YX/p"),
      fImg: __webpack_require__("YX/p"),
      fImg2: __webpack_require__("rmeM"),
      uCount: 0,
      uSrc: __webpack_require__("J8Hx"),
      uImg: __webpack_require__("J8Hx"),
      uImg2: __webpack_require__("eYHf")
    };
  },

  methods: {
    isShow: function isShow(index) {
      return this.active === index;
    },
    toggle: function toggle(i) {
      if (i === 3) {
        if (this.fCount === 0) {
          this.fSrc = this.fImg2;
          this.fCount++;
        } else {
          this.fSrc = this.fImg;
          this.fCount--;
        }
      } else if (i === 4) {
        if (this.uCount === 0) {
          this.uSrc = this.uImg2;
          this.uCount++;
        } else {
          this.uSrc = this.uImg;
          this.uCount--;
        }
      }
    },
    changeColor: function changeColor(i) {
      if (i === 3) {
        return this.fCount === 1;
      } else {
        return this.uCount === 1;
      }
    }
  },
  components: {
    $: $
  },
  mounted: function mounted() {
    var width = $(window).width();
    if (width >= 1250) {
      $(document).ready(function () {
        $('.zoom').magnify({
          speed: 100
        });
      });
    }
  },

  watch: {}
});

/***/ }),

/***/ "eYHf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ubase2.69ab83f.png";

/***/ }),

/***/ "fzGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_board_vue__ = __webpack_require__("eCFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059e6d32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_board_vue__ = __webpack_require__("hDGN");
function injectStyle (ssrContext) {
  __webpack_require__("w0bF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-059e6d32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_board_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059e6d32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_board_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gAOZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/f.25e020e.jpg";

/***/ }),

/***/ "hDGN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_c('img', {
    staticClass: "board-img zoom",
    class: {
      show: _vm.isShow(2)
    },
    attrs: {
      "src": __webpack_require__("CGHv"),
      "data-magnify-src": "/static/ttop.png",
      "alt": "ttop"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img _bottom",
    class: {
      show: _vm.isShow(2)
    },
    attrs: {
      "src": __webpack_require__("Yg+W"),
      "alt": "tbase"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img zoom",
    class: {
      show: _vm.isShow(3)
    },
    attrs: {
      "src": __webpack_require__("D+9/"),
      "data-magnify-src": "/static/ftop.png",
      "alt": "ftop"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img _bottom",
    class: {
      show: _vm.isShow(3)
    },
    attrs: {
      "src": _vm.fSrc,
      "alt": "fbase"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toggle __f",
    class: {
      show: _vm.isShow(3), fSec: _vm.changeColor(3)
    },
    on: {
      "click": function($event) {
        _vm.toggle(3)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img zoom",
    class: {
      show: _vm.isShow(4)
    },
    attrs: {
      "src": __webpack_require__("/5xu"),
      "data-magnify-src": "/static/utop.png",
      "alt": "utop"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "board-img _bottom",
    class: {
      show: _vm.isShow(4)
    },
    attrs: {
      "src": _vm.uSrc,
      "alt": "ubase"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toggle __u",
    class: {
      show: _vm.isShow(4), uSec: _vm.changeColor(4)
    },
    on: {
      "click": function($event) {
        _vm.toggle(4)
      }
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hnT7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ioyw":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "jHNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buyButton__ = __webpack_require__("OPWT");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rightBlock',
  props: ['active'],
  data: function data() {
    return {
      showModal: false,
      showModalFinal: false,
      activeItem: 1,
      list: ['MD', 'M/L', '109,1', '29,1', '29,1', '25,3', '54', 0, '7,5', '60-75'],
      itemList: ['151', '155', '160w', '164w'],
      selectedItem: '151',
      item1: '151',
      item2: '155',
      item3: '160w',
      item4: '164w',
      item5: null,
      selected: 'Сноуборд Phantom U (оранжевая база)',
      selectList: ['Сноуборд Phantom T', 'Сноуборд Phantom F (черная база)', 'Сноуборд Phantom F (белая база)', 'Сноуборд Phantom U (оранжевая база)', 'Сноуборд Phantom U (черная база)'],
      selectOpen: false,
      selectOpenSpec: false,
      price: '45000',
      index: 1,
      name: '',
      address: '',
      city: '',
      phone: '',
      mail: ''
    };
  },

  computed: {
    formData: function formData() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        "customerContact": this.phone,
        "taxSystem": 3,
        "items": [{
          "quantity": 1,
          "price": {
            "amount": this.price
          },
          "tax": 4,
          "text": this.selected + ' ' + this.selectedItem
        }],
        "paymentMethodType": "full_prepayment",
        "paymentSubjectType": "commodity"
      });
    },
    computedAddress: function computedAddress() {
      return this.address + ' ' + this.city;
    },
    computedModel: function computedModel() {
      return this.selected + ' ' + this.selectedItem;
    },
    isPhone: function isPhone() {
      var phoneReg = /^\+7[0-9]{10,11}/;

      var isPhone = this.phone.match(phoneReg);

      return isPhone;
    }
  },
  methods: {
    submitForm: function submitForm(form, event) {
      if (this.isPhone) {
        form.submit();
      }
      event.preventDefault();
      return false;
    },
    showInput: function showInput() {
      return this.index === 2;
    },
    showInputCity: function showInputCity() {
      return this.index === 3;
    },
    isShow: function isShow() {
      return this.active === 2 || this.active === 3 || this.active === 4;
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.showModalFinal = false;
    },
    closeFinalModal: function closeFinalModal() {
      this.showModalFinal = false;
      this.name = '';
      this.address = '';
      this.city = '';
      this.phone = '';
      this.mail = '';
    },
    openModal: function openModal() {
      this.showModal = true;

      if (window.innerWidth <= 1250) {
        window.scrollTo(0, 0);
      }
    },
    openFinalModal: function openFinalModal(i) {
      this.showModalFinal = true;
      this.index = i;
    },
    activate: function activate(index) {
      this.activeItem = index;
    },
    isActive: function isActive(index) {
      return this.activeItem === index;
    },
    isNone: function isNone() {
      if (this.item5 === 'hid') {
        return true;
      } else {
        return false;
      }
    },
    changeSelect: function changeSelect(item) {
      this.selected = item;
      if (item === this.selectList[0]) {
        this.itemList = ['151', '155', '160w', '164w'];
        this.price = '45000';
      } else if (item === this.selectList[1] || item === this.selectList[2]) {
        this.itemList = ['150', '156', '163w'];
        this.price = '45000';
      } else if (item === this.selectList[3] || item === this.selectList[4]) {
        this.itemList = ['151', '156', '161w', '165w', '172w'];
        this.price = '45000';
      }
      this.selectedItem = this.itemList[0];
    },
    changeSelectItem: function changeSelectItem(item) {
      this.selectedItem = item;
    },
    openSelect: function openSelect() {
      this.selectOpen = !this.selectOpen;
      this.selectOpenSpec = false;
    },
    openSelectSpec: function openSelectSpec() {
      this.selectOpen = false;
      this.selectOpenSpec = !this.selectOpenSpec;
    }
  },
  components: {
    buyButton: __WEBPACK_IMPORTED_MODULE_1__buyButton__["a" /* default */]
  },
  watch: {
    activeItem: function activeItem() {
      if (this.active === 2) {
        if (this.activeItem === 1) {
          this.list = ['MD', 'M/L', '109,1', '29,1', '29,1', '25,3', '54', 0, '7,5', '60-75'];
        } else if (this.activeItem === 2) {
          this.list = ['MD', 'M/L', '112,5', '29,4', '29,4', '25,5', '55', 0, '7,7', '60-75'];
        } else if (this.activeItem === 3) {
          this.list = ['HD', 'L', '115,9', '29,9', '29,9', '25,8', '56', 0, '7,9', '75-90'];
        } else if (this.activeItem === 4) {
          this.list = ['HD', 'L', '119,2', '30,4', '30,4', '26,2', '57', 0, '8,1', '75-90'];
        }
      } else if (this.active === 4) {
        if (this.activeItem === 1) {
          this.list = ['MD', 'M', '106,7', '29,6', '28,6', '25,4', '55', '3,4', '7,9', '60-75'];
        } else if (this.activeItem === 2) {
          this.list = ['MD', 'M/L', '110,9', '29,7', '28,8', '25,7', '55', '3,6', '8,3', '60-75'];
        } else if (this.activeItem === 3) {
          this.list = ['HD', 'L', '114,2', '30,2', '29,3', '26', '56', '3,7', '8,5', '75-90'];
        } else if (this.activeItem === 4) {
          this.list = ['HD', 'L', '117,5', '30,7', '29,7', '26,4', '57', '3,7', '8,75', '75-90'];
        } else if (this.activeItem === 5) {
          this.list = ['HD+', 'L', '122,3', '30,9', '29,8', '26,4', '57', '3,9', '9,1', '90+'];
        }
      } else if (this.active === 3) {
        if (this.activeItem === 1) {
          this.list = ['MD', 'M/L', '111,6', '30,2', '27,4', '25', '53', '6,3', '8,1', '60-75'];
        } else if (this.activeItem === 2) {
          this.list = ['HD', 'M/L', '116,2', '30,7', '27,8', '25,2', '55', '6,5', '8,3', '75-90'];
        } else if (this.activeItem === 3) {
          this.list = ['HD+', 'L', '120,9', '32', '28,9', '26,2', '56', '6,8', '8,5', '90+'];
        }
      }
    },
    active: function active() {
      this.activeItem = 1;
      if (this.active === 2) {
        this.item1 = '151';
        this.item2 = '155';
        this.item3 = '160w';
        this.item4 = '164w';
        this.item5 = null;
        this.selected = 'Сноуборд Phantom T';
        this.price = '45000';
        if (this.activeItem === 1) {
          this.list = ['MD', 'M/L', '109,1', '29,1', '29,1', '25,3', '54', 0, '7,5', '60-75'];
        } else if (this.activeItem === 2) {
          this.list = ['MD', 'M/L', '112,5', '29,4', '29,4', '25,5', '55', 0, '7,7', '60-75'];
        } else if (this.activeItem === 3) {
          this.list = ['HD', 'L', '115,9', '29,9', '29,9', '25,8', '56', 0, '7,9', '75-90'];
        } else if (this.activeItem === 4) {
          this.list = ['HD', 'L', '119,2', '30,4', '30,4', '26,2', '57', 0, '8,1', '75-90'];
        }
      } else if (this.active === 3) {
        this.item1 = '150';
        this.item2 = '156';
        this.item3 = '163w';
        this.item4 = null;
        this.item5 = null;
        this.selected = 'Сноуборд Phantom F (черная база)';
        this.price = '45000';
        if (this.activeItem === 1) {
          this.list = ['MD', 'M/L', '111,6', '30,2', '27,4', '25', '53', '6,3', '8,1', '60-75'];
        } else if (this.activeItem === 2) {
          this.list = ['HD', 'M/L', '116,2', '30,7', '27,8', '25,2', '55', '6,5', '8,3', '75-90'];
        } else if (this.activeItem === 3) {
          this.list = ['HD+', 'L', '120,9', '32', '28,9', '26,2', '56', '6,8', '8,5', '90+'];
        }
      } else if (this.active === 4) {
        this.item1 = '151';
        this.item2 = '156';
        this.item3 = '161w';
        this.item4 = '165w';
        this.item5 = '172w';
        this.price = '45000';
        this.selected = 'Сноуборд Phantom U (оранжевая база)';
        if (this.activeItem === 1) {
          this.list = ['MD', 'M', '106,7', '29,6', '28,6', '25,4', '55', '3,4', '7,9', '60-75'];
        } else if (this.activeItem === 2) {
          this.list = ['MD', 'M/L', '110,9', '29,7', '28,8', '25,7', '55', '3,6', '8,3', '60-75'];
        } else if (this.activeItem === 3) {
          this.list = ['HD', 'L', '114,2', '30,2', '29,3', '26', '56', '3,7', '8,5', '75-90'];
        } else if (this.activeItem === 4) {
          this.list = ['HD', 'L', '117,5', '30,7', '29,7', '26,4', '57', '3,7', '8,75', '75-90'];
        } else if (this.activeItem === 5) {
          this.list = ['HD+', 'L', '122,3', '30,9', '29,8', '26,4', '57', '3,9', '9,1', '90+'];
        }
      }
    }
  }
});

/***/ }),

/***/ "jsm/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAhUAAAASCAQAAABGd+RkAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAYSSURBVHja7Vvbdas6EN26Kw3olMAtQacEXAIuAZcgl4BLwCVACbgEKMGUACXs++HkxLFBM3JwyLonk68keszWlkbzEAazQguYET/yIysIrabVz/78BsKMJOnX1uNH/kahpU4GVkzW1vbvEDP9Zzo06NAjx8ac1lbyR/42ocWAGrXQLIFDhhG/Tb+2xv9/mTQVtGgAbMzIFkk8EWHnMd5pnBpPMwptzFzh1us7xHFoYvrIrebQPwsvLQYczF7R0qNAbbaP6a9FExOMa9s+uqvfen8LZtlwoLsMxIGtbqH/9M4Ep7Flqw1smLFiO+N6tvQXLWd7l284FDO1HOZxipjeJGqlola1JFlG9rEkG8lBpyVZBFvMo2/ZspF4eACtqNNV25at0OKT7NGy1AbjLCSeaOnZcphZz4q5cn2+mNmXie4lUmxNBwBm5AYNSghW+05C7RM4FEzMTgCaoESKE2ocJv5t4ZCjYODuMTsCDTcXLMG5SiTYCJZUsQZPu2UL5DgiZ28OkV0dWh6ie2nRWyRIkKPgEftvnWT8BHtmxI69vGdpUSLFPrTa9PAYccIRU7MlSFEyx07es6szS39rP+nj7jNm8u3KghQ8gos/kwrjCLrRsuVZ1KYkmX0W0/PkjZN7boR+lmRGH15J5d0TRH+ZY0HEMV7FmZXQYhH2mHJgO3+T07FlK+zqQsZFx1byhr8Bs8ymjh6LmC2qMhWZeDirUEDwAUpwJFq24RBKcwDXNBXM3/VjSUrm8wN2MgOYsCFZTCNYYkMBTPWHW6m5YjQmLDmIjvhC7NGy5TC92+g5sBKOnVOisjyzEddnTWbpOEyrGLNFVdN7MkQwE71xkm4VJhzmW1wfxM9heo7Qcbg23lH5F/tuRplz4Hlqmy+zoQBWPC+G2pI8sxV/KN3jev2Vmk1mLVhqjABLDspZfNjrXoPZl+uBUWKciVz2cKgYUQsJKpDB4xgcywHQztUhuFlMzw0allNxJh0KHLXx3tKVHcWMCRqcrjU3O16YiJzNHFmjQMUauyflFDpkdIoYWys95LFGJKh4MEd5uGXYMzv28Eze43daVHDYGqm0Czj1nj4BSBX48XXMXv3+XveYEn0tRJVvbsI+Ssw9wELhxUz6DnQhfyMa0+Jex3TwJIdUVy1vgjNmPHO4yUUtdfeIQWUUcn2uwpPhqsHS7NHx/ObNMOU5lMH40K9VYxLwr8HsP39+veRuZ+2YGbFBAm1681fwZ4sOlej2a2Nyi16ypuaIPYrbhUSJHkIdRo3p19IW/f11yw2WOCY+9q3NvziiYLN0eROABbBCDcQc0EEuMC7InunwGz0a5vRocMJG7W3r93TkWj6f2dcAhB45OiSC1euRTTvyE6qHgNaoCXjMO/49AO2D3VTj1pkDLQr2b27i3EF8GNPyUswVcC8lbC0Td733rFGgpeqJU4Q4jCu97D3By4+NlmTPjNiyQAmES6M30kN7jDNAF3580OqpzL4AADMU6KCxed1Dtf3pkSyzufjOdDwh51GmlzkSKCJVwOxpUbJ/9ZwKxUuKFYUlcvQoOddgRM7xsS1hOmzo4ZnioIiwdfo6ZOJD7GfJ8veoQsyeKRB1Fmpk9KoeGfpHzO6TmaWLqYnLtRBl/FMINRAXrmK/tso/1gfEWZtLCTamjqDHtJxcCrjMgj9ikfc+or35b0WyZLJA9T2Lf9Uraq6N6zNSKC0+iT35nehdD8WrT1pWuncVwREWZ/blte6xUaPV1UJShkdJkaMOjWE6blCh5QmnyVx4igQpUhyj3PAtGjQ8IQ/lZR7EBGAZS06PQuPYEtchVayYEVvm8NClIufRO6RwWD7/7lTGwiHFCNm7+jL2gjPsCBTMUKNHd5eNSOBeP4BTvDAOzPIcZsN1jymRaiGqfLMyF0zPZnaMMyv9c6Qr7c9xbx7VmBaqgsQ8Zgp7R+G7508b8U2AgL5lGc+DqJVWWpaqJ1hPYC/eqwAAOpY8B/B4hU++ArPmke8VP/8VZtwXn7B30eiI7vE77LFvNDWtlrlXY/STmHju94fLYY6ZMX729b8LntDI4VarDqP++9WvZvY/AQS/kLNZVIUAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTctMTAtMThUMDM6MzA6MDIrMDA6MDA9xRUjAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE3LTEwLTE4VDAzOjMwOjAyKzAwOjAwTJitnwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "juKD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preloader_vue__ = __webpack_require__("01iT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_333608a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__ = __webpack_require__("TXM7");
function injectStyle (ssrContext) {
  __webpack_require__("hnT7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preloader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_333608a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kkaB":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "onfS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/phantom_f.e97ed98.png";

/***/ }),

/***/ "rmeM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fbase2.846487d.png";

/***/ }),

/***/ "w0bF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wErx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/phantom_u.2a9289a.png";

/***/ }),

/***/ "x1is":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("xZxk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09227c25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("QSgK");
function injectStyle (ssrContext) {
  __webpack_require__("3MYv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09227c25"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09227c25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Content__ = __webpack_require__("x1is");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Content: __WEBPACK_IMPORTED_MODULE_0__components_Content__["a" /* default */]
  },
  data: function data() {
    return {
      activeItem: 0,
      changeWatcher: 0
    };
  },
  created: function created() {
    var self = this;
    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 39) {
        self.changeWatcher++;
        self.activeItem = 1;
      } else if (event.keyCode === 37) {
        self.changeWatcher++;
        self.activeItem = -1;
      }
    });
  },

  methods: {
    swipeHandler: function swipeHandler(e) {
      if (e === 'right') {
        this.changeWatcher++;
        this.activeItem = -1;
      } else if (e === 'left') {
        this.changeWatcher++;
        this.activeItem = 1;
      }
    }
  }
});

/***/ }),

/***/ "xQDS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMi42MSAxMy42NyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiMwMDA7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjEuMjVweDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnJ1YjwvdGl0bGU+PGcgaWQ9ItCh0LvQvtC5XzIiIGRhdGEtbmFtZT0i0KHQu9C+0LkgMiI+PGcgaWQ9IkxheWVyXzEiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggZD0iTTQuMjUsOHY1LjdIMi43OFYwaDQuOGMzLDAsNSwxLjQ4LDUsMy42NXYuNjhjMCwyLjE0LTIsMy42NS01LDMuNjVabTAtNi44djUuNmgzLjNjMi4xOSwwLDMuNjEtMSwzLjYxLTIuNFYzLjU5YzAtMS40My0xLjQyLTIuNDItMy42MS0yLjQyWiIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeTE9IjEwLjg4IiB4Mj0iOC43NSIgeTI9IjEwLjg4Ii8+PGxpbmUgY2xhc3M9ImNscy0xIiB5MT0iNy4zMSIgeDI9IjIuNzUiIHkyPSI3LjMxIi8+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ "xZxk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logo__ = __webpack_require__("2AE9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Preloader__ = __webpack_require__("juKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__board__ = __webpack_require__("fzGx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RightBlock__ = __webpack_require__("ADVM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeftBlock__ = __webpack_require__("df53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footerComponent__ = __webpack_require__("csnC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blackLogo__ = __webpack_require__("PA35");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Content',
  props: ['active', 'change'],
  data: function data() {
    return {
      activeItem: 1,
      show: false,
      isShow: false,
      isDisplay: false,
      pos: 0
    };
  },

  components: {
    Logo: __WEBPACK_IMPORTED_MODULE_0__Logo__["a" /* default */],
    Preloader: __WEBPACK_IMPORTED_MODULE_1__Preloader__["a" /* default */],
    board: __WEBPACK_IMPORTED_MODULE_2__board__["a" /* default */],
    rightBlock: __WEBPACK_IMPORTED_MODULE_3__RightBlock__["a" /* default */],
    leftBlock: __WEBPACK_IMPORTED_MODULE_4__LeftBlock__["a" /* default */],
    blackLogo: __WEBPACK_IMPORTED_MODULE_6__blackLogo__["a" /* default */],
    footerComponent: __WEBPACK_IMPORTED_MODULE_5__footerComponent__["a" /* default */]
  },
  methods: {
    displayMainPage: function displayMainPage() {
      return this.activeItem !== 1;
    },
    displayMain: function displayMain() {
      return this.activeItem === 1 || this.activeItem === 5;
    },
    posfunc: function posfunc(index) {
      var width = $(window).width();
      var prev = this.activeItem;
      var diff = 0;
      if (prev > index) {
        if (prev === 5 && index === 1) {
          diff = -999;
        } else {
          diff = -(prev - index);
        }
      } else if (prev < index) {
        diff = index - prev;
      }
      if (width >= 1250) {
        if (diff === -999) {
          this.pos = 0;
        } else {
          this.pos = this.pos + diff * 25;
        }
      }
      this.activeItem = index;
    },
    isActive: function isActive(index) {
      return this.activeItem === index;
    },
    isBlur: function isBlur(i) {
      return this.activeItem === i;
    }
  },
  created: function created() {
    var self = this;
    window.addEventListener('load', function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
        self.show = true;
      }, 0);
    });
  },

  watch: {
    change: function change() {
      var index = this.activeItem;
      if (this.active > 0 && index !== 5) {
        index++;
        this.posfunc(index);
      } else if (this.active < 0 && index !== 1) {
        index--;
        this.posfunc(index);
      } else if (index === 5) {
        index = 1;
        this.posfunc(index);
      } else if (index === 1) {
        index = 5;
        this.posfunc(index);
      }
    }
  }
});

/***/ }),

/***/ "yaIG":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "zzH9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Content', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipe",
      value: (_vm.swipeHandler),
      expression: "swipeHandler",
      arg: "swipe"
    }],
    attrs: {
      "active": _vm.activeItem,
      "change": _vm.changeWatcher
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3afa884afa597e36abc9.js